<script>
import each from 'lodash/each';
import vueMixins from 'viralstyle-ui/src/vueMixins';
import VsIconButton from 'viralstyle-ui/src/VsIconButton';
import VsTable from 'viralstyle-ui/src/VsTable';
import { mapState } from 'vuex';

export default {
  components: {
    VsTable,
    VsIconButton,
  },
  mixins: [vueMixins],
  props: {
    selectable: [Boolean, String],
  },
  data: () => ({
    headings: ['First Name', 'Last Name', 'Email'],
  }),
  computed: {
    ...mapState({
      processing: state => state.processing,
      paymentInfo: state => state.settings.paymentInfo,
      currentPayoneerAccountId: state => state.settings.currentPayoneerAccountId,
    }),
  },
  watch: {
    'paymentInfo.payoneer_accounts' () {
      this.headings = ['First Name', 'Last Name', 'Email'];

      if (!this.selectable) this.headings.push('Default');
      if (!this.selectable && this.get(this.paymentInfo, 'payoneer_accounts.length') > 1) this.headings.push('Unlink');

      if (this.selectable) {
        each(this.paymentInfo.payoneer_accounts, account => {
          if (account.is_default) this.selectAccount(account.account_id);
        });
      }
    },
  },
  methods: {
    selectAccount(id) {
      this.$store.commit('setCurrentPayoneerAccountId', id);
    },
    setDefault(id) {
      this.$store.dispatch('setDefaultPayoneer', id);
    },
    unlink(id) {
      this.$store.dispatch('unlinkPayoneer', id);
    },
    rowSelected(account) {
      return (!this.currentPayoneerAccountId && account.is_default || this.currentPayoneerAccountId === account.account_id) && this.selectable;
    },
  },
};
</script>

<template lang='pug'>
vs-table(
  is-large,
  :headings='headings',
  :selectable='selectable',
)
  .vs-table__row(
    v-for='account in paymentInfo.payoneer_accounts',
    :class='{ "vs-table__row--selected": rowSelected(account), "vs-table__row--action": !selectable }',
    @click='selectAccount(account.account_id)',
  )
    .vs-table__cell(:data-heading='headings[0]')
      h6 {{account.first_name}}
    .vs-table__cell(:data-heading='headings[1]')
      h6 {{account.last_name}}
    .vs-table__cell.vs-table__cell--break(:data-heading='headings[2]')
      h6 {{account.email}}
    .vs-table__cell(v-if='!selectable', data-heading='Default')
      vs-icon-button.vs-icon-button--margin(
        type='toggle',
        icon='check',
        :inactive='!account.is_default',
        :processing='processing',
        :disabled='processing || account.is_default',
        @click='setDefault(account.account_id)',
      )
    .vs-table__cell(v-if='!selectable && get(paymentInfo, "payoneer_accounts.length") > 1', data-heading='Unlink')
      vs-icon-button.vs-icon-button--margin(
        v-if='!account.is_default',
        type='delete',
        icon='close',
        :processing='processing',
        :disabled='processing',
        @click='unlink(account.account_id)',
      )
</template>

<style>
@import '~import/index';
</style>